// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import axios from 'axios'
import axios from "@/utils/axios";
import pinterest from "@/directives/pinterest";
import loginout from "@/directives/loginout";

import Vue from "vue";
// import "amfe-flexible/index"
// import 'lib-flexible/flexible'

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "./theme/index.css";
// import './theme/element-variables.scss'
Vue.use(ElementUI);
import App from "./App";

import "@/permission";
// import myHeader from './components/myHeader'
// import mySearch from './components/mySearch'

import VueParticles from "vue-particles";
import gloablMixin from "./mixin";
import "@/public.scss";
// 过滤器
import * as filters from "@/filters";
import PubSub from "pubsub-js";

import tool from "@/utils/tool";
import VueAwesomeSwiper from "vue-awesome-swiper";

// import style
import "swiper/css/swiper.css";

// 图片全屏预览
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

import VueLazyload from "vue-lazyload";
// 引入拖拽排序插件
import VueDND from "awe-dnd";
import router from "./router";

import VueQuillEditor from "vue-quill-editor";
import animated from "animate.css";

// 引入样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import VueCoreVideoPlayer from 'vue-core-video-player' //播放器组件

import "./plugins/video.js"; // 引入刚刚定义的video.js文件
ElementUI.Dialog.props.lockScroll.default = false; //防止有滚动条的页面抖动

// 引入videojs
// import Video from 'video.js';
// import 'video.js/dist/video-js.css';
// Vue.prototype.$video = Video;
// import 'videojs-flash'; // 要播放rtmp流, 就必须引入这哥们
// 引入全局自动注册组件
import allComponents from "@/utils/bathComponents";
Vue.use(allComponents);
import storage from "@/utils/localstorage";
// 滚动动画 wow.js
import { WOW } from "wowjs";
Vue.prototype.$wow = new WOW({
  boxClass: "wow", // default
  animateClass: "animated", // default
  offset: 50, // default
  mobile: true, // 是否在移动设备上执行动画
  live: false,

  // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.

  callback: function (box) {
    // console.log("WOW: animating <" + box.tagName.toLowerCase() + ">");
  }
});



Vue.use(VueCoreVideoPlayer, {
  lang: 'zh-CN'
})

Vue.use(storage);

Vue.use(animated);

Vue.use(VueQuillEditor /* { 默认全局 } */);

Vue.use(VueDND);

Vue.use(VueLazyload);

// or with options
// const loadimage = require('./assets/loading.gif')
// const errorimage = require('./assets/error.gif')

Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: errorimage,
  // loading: loadimage,
  // lazyComponent: true,
  // listenEvents:['scroll'],//你想要 Vue 监听的事件
  attempt: 1
});



Vue.use(Viewer, {
  defaultOptions: {
    // 需要配置的属性
    toolbar: false,
    navbar: false,
    title: false,
    zIndex: 9999,
  }
});


Viewer.setDefaults({
  url: "data-source",// 大图地址参数
  // filter(image) {
  //   // 只有大图的才能放大
  //   let dataSource = image.getAttribute('data-source')
  //   if (dataSource == null || dataSource == undefined) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // }
});

// Viewer.setDefaults({
//   Options: {
//   // 'inline': true, //启用lnline模式
//   // 'button': true, //显示右上角关闭按钮
//   // 'navbar': false, //显示缩略图导航
//   // 'title': true, //显示当前图片的标题
//   // 'toolbar': false, //显示工具栏
//   // 'tooltip': true, //显示缩放百分比
//   // 'movable': true, //显示可移动
//   // 'zoomable': true, //图片是否可缩放
//   // 'rotatable': true, //图片是否可旋转
//   // 'scalable': true, //图片是否可翻转
//   // 'transition': true, //使用css3过度
//   // 'fullscreen': true, //播放时是否全屏
//   // 'keyboard': true, //是否支持键盘
//   // 'url': 'data-source' //设置大图片的url
//   }
// })

Vue.use(VueAwesomeSwiper /* { default options with global component } */);

Vue.use(tool);
Vue.use(PubSub);

Object.keys(filters).forEach(item => {
  Vue.filter(item, filters[item]);
});

// 主题颜色
// import './theme/element-variables.scss'

Vue.use(VueParticles);

// Vue.component('myHeader',myHeader)
// Vue.component('mySearch',mySearch)
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.pinterest = pinterest;
Vue.prototype.loginout = loginout;
Vue.mixin(gloablMixin);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  // 安装全局事件总线
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
  template: "<App/>"
  // render: h => h(App) //el中的示例
});



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = null
// module chunks = 